import { render, staticRenderFns } from "./anketa.vue?vue&type=template&id=2fdebf17"
import script from "./anketa.vue?vue&type=script&lang=js"
export * from "./anketa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports